
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';

// Automatische herschrijving van schone paden naar hash-gebaseerde paden om compatibiliteit te behouden
// met HashRouter op hostingplatformen terwijl directe invoer (zoals /admin) blijft werken.
const pathname = window.location.pathname;
if (pathname && pathname !== '/' && !pathname.includes('.')) {
  const hashPath = pathname.replace(/^\//, '');
  window.location.replace(`${window.location.origin}/#/${hashPath}${window.location.search}${window.location.hash}`);
} else {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error("Could not find root element to mount to");
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HashRouter>
        <App />
      </HashRouter>
    </React.StrictMode>
  );
}
